import Api from '@api/eSchool'
import { observable, action } from 'mobx'

class Store {
  @observable eSchoolList = []
  @observable hasMore = true
  @observable page = 1
  @observable types = []
  @observable currentType = '0'
  @observable spinning = false

  @action
  getESchoolList = async (page = 1) => {
    this.spinning = true
    this.page = page

    const {
      data: { list, page_count }
    } = await Api.eSchoolList({
      type: this.currentType,
      page: page,
      per_page: 5
    })

    if (page == 1) {
      this.eSchoolList = []
    }

    if (this.page >= page_count) {
      this.hasMore = false
    }

    this.spinning = false
    this.eSchoolList = this.eSchoolList.concat(list || [])
  }

  @action
  loadMore = () => {
    this.getESchoolList(++this.page)
  }

  @action
  changeType = index => {
    this.currentType = index
    this.hasMore = true
    this.getESchoolList(1)
  }

  @action
  init = async () => {
    const { data, success } = await Api.getTypes()
    if (success) {
      this.types = data
      this.currentType = data[0].id
      this.getESchoolList(1)
    }
  }
}

export default Store
